import { Component, computed, inject } from "@angular/core"
import { RouterLink } from "@angular/router"
import { NgOptimizedImage } from "@angular/common"
import { UnderwritingManualDialogComponent } from "./underwriting-manual.dialog.component"
import { StorageService } from "../../../../services/storage.service"

@Component({
  imports: [
    RouterLink,
    NgOptimizedImage,
    UnderwritingManualDialogComponent,
  ],
  standalone: true,
  styles: [`
    .underwriting-link {
      margin: 0 auto;
      width: 350px;
      display: block;
      position: relative;
    }

    .underwriting-link .manual {
      position: absolute;
      top: 0;
      left: 0;
      transform: scale(1);
    }

    .underwriting-link .manual {
      transition: all 0.3s ease;
    }

    .underwriting-link:hover .manual {
      top: calc(-10% / 2);
      left: calc(-10% / 2);
      transform: scale(1.1);
    }
  `],
  template: `
    <div class="p-10">
      <div
        class="row laptop:flex-nowrap gap-5 rounded-lg items-stretch"
        data-theme="redline_dark"
      >
        <a
          class="underwriting-link w-full laptop:w-1/4 self-center px-5"
          [routerLink]="[]"
          fragment="underwriting-manual"
          queryParamsHandling="preserve"
        >
          <img
            class="bg"
            [ngSrc]="manualButtonSrc()"
            width="600"
            height="570"
            alt=""
            priority=""
          >
          <img
            class="manual"
            [ngSrc]="manualButtonLargeSrc()"
            width="600"
            height="570"
            priority=""
            alt="A photocopy of the cover of the Federal Housing Administration's Underwriting Manual"
          >
        </a>
        <div class="w-full laptop:w-1/2 p-8 self-center">
          <div>
            Redlining manuals instructed surveyors to indicate “hazardous infiltration” which could include
            “negroes” or “foreign born populations.” This made race synonymous with property value. As time when
            on, particularly after WWII, demographics like Irish, Italians and Jewish were included as “white,”
            allowing them to access growing, homogeneous, middle class suburbs. People of color, including blacks
            and hispanics, were increasingly concentrated in Redlined areas.
          </div>
          <div>
            As the suburbs were first built, “racial covenants” and “deed restrictions” kept non-whites from being
            able to move to these new areas of investment. Eventually, this built the American landscape we are
            familiar with today: concentrated areas of poverty in diverse, often urban neighborhoods, with
            wealthier and Whiter suburbs surrounding them.
          </div>
          <div>
            This geographic structure means that vastly different services, schools, infrastructure, housing
            quality, policing and more remain largely determined by race and class, but only need to associate to
            zip codes. By the 1960s Civil Rights Acts, explicit racism was removed from most policy, and Redlining
            was made illegal. However, this structural geography largely remains today. It has never been undone.
          </div>
        </div>
        <div class="w-full laptop:w-1/4 relative">
          <img
            class="rounded-tr-lg rounded-br-lg"
            style="object-fit: cover; object-position: top; position: relative; width: 100%; height: 100%; min-height: 600px;"
            [ngSrc]="areaDescriptionGraphic()"
            fill
            alt=""
          />
        </div>
      </div>
    </div>
    <e2e-underwriting-manual-dialog/>

  `,
  selector: "e2e-underwriting-manual",
})
export class UnderwritingManualComponent {
  private storageService = inject(StorageService)

  manualButtonSrc = computed(() =>
    this.storageService.getFileUrl("/assets/images/S2-Underwriting-Manual-Button-Bg.png")
  )
  manualButtonLargeSrc = computed(() =>
    this.storageService.getFileUrl("/assets/images/S2-Underwriting-Manual-Button-LargeManual.png")
  )
  areaDescriptionGraphic = computed(() =>
    this.storageService.getFileUrl("/assets/images/S2-Underwriting-Manual-Area-Description-Graphic.png")
  )

}
